import { render, staticRenderFns } from "./AlertListSection-v2.vue?vue&type=template&id=46e8ad6e&"
import script from "./AlertListSection-v2.vue?vue&type=script&lang=js&"
export * from "./AlertListSection-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports